import { useContext, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { SuperAdminContext } from '../../context api/SuperAdmin/SuperAdminContext'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { API_URL } from '../../shared/actions'
import { useDownload } from '../../hooks/Download/useDownload'

export const useSubscription = () => {
  const [subscription, setSubscription] = useState(false)
  const { getNewSubscriptions,  getSingleSubscription } = useContext(SuperAdminContext)
  const [active, setActiveSubscriptions ] = useState();
  const [purchasedSubs, setPurchasedSubs ] = useState();
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)
  const { getPdfCsvData, pdfCsvData, setPdfCsvData, } = useDownload();
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [expiringPlans, setExpiringPlans] = useState([])
  // (setLoading, message, redirect, getUrl)
  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'Subscription', 'ALL_SUBSCRIPTION_PLANS', 'GET_ALL_SUBSCRIPTIONS')
  const {
    SUBSCRIPTIONS: { GET_ALL_SUBSCRIPTIONS, ADD_SUBSCRIPTION, EDIT_SUBSCRIPTION, DELETE_SUBSCRIPTION, GET_SUBSCRIPTION, ACTIVE_SUBSCRIPTIONS, ABOUT_TO_EXPIRE_PLANS,
      ACTIVE_SUBSCRIPTION_WITH_PURCHASES},
  } = API_URL

  const getAllSubscriptions = async (dto = {}) => {
    GET_ALL(GET_ALL_SUBSCRIPTIONS, setPaginate, getNewSubscriptions, dto)
    setDownloadLoading(true);
    getPdfCsvData('GET_ALL_SUBSCRIPTIONS', dto)
    setDownloadLoading(false)
  }
  const subscriptionWithPurchases = async (dto = {}) => {
    GET_ALL(ACTIVE_SUBSCRIPTION_WITH_PURCHASES, setPaginate, setPurchasedSubs, dto)
  }
  const aboutToExpirePlans = async (dto = {}) => {
    GET_ALL(ABOUT_TO_EXPIRE_PLANS, setPaginate, setExpiringPlans, dto)
  }

  const addSubscription = (dto) => {
    ADD(ADD_SUBSCRIPTION, dto)
  }
  const updateSubscription = (dto) => {
    UPDATE(EDIT_SUBSCRIPTION, dto)
  }

  const getSubscription = (dto) => {
    // return getSingleSubscription(dto.id);
    GET_SINGLE_DATA(GET_SUBSCRIPTION, setSubscription, dto.id)
  }

  const activeSubscriptions= (dto) =>{
    GET_ALL(ACTIVE_SUBSCRIPTIONS, ()=>{}, setActiveSubscriptions, dto)
  }

  // const deleteSubscription = (dto, setSelected = () => {}) => {
  //   DELETE(DELETE_SUBSCRIPTION, dto)

  // }

  const deleteMany = (dto, setSelected = () => {}) => {
    DELETE(DELETE_SUBSCRIPTION, dto)
    getAllSubscriptions()
    // for( let i=0; i<dto.ids.length; i++ ){
    //   let id = dto.ids[i];
    //   console.log(id)
    //   deleteSubscription({id: id}, setSelected)
    // }
  }

//   const deleteManySubscription = (dto, setSelected = () => {}) => {
//     DELETE(DELETE_SUBSCRIPTION, dto, 'superAdminId', setSelected, deleteNewSuperAdmin, 'GET_ALL_SUPERADMINS')
//   }

  return {
    addSubscription,
    getAllSubscriptions,
    getSubscription,
    subscription,
    updateSubscription,
    activeSubscriptions,
    aboutToExpirePlans,
    active,
    purchasedSubs,
    subscriptionWithPurchases,
    // wleteSubscription,
    deleteMany,
    loading,
    expiringPlans,
    paginate,
    pdfCsvData,
    downloadLoading
  }
}
